module.exports = __webpack_public_path__ + "static/media/video-bolsas-y-zapatos-2020.7d60bf8e.jpg";